import React, { useState } from 'react';
import { GoogleGenerativeAI } from '@google/generative-ai';
import { Colxx } from '../../../components/common/CustomBootstrap';
import HotTable from '@handsontable/react';
import { Row } from 'reactstrap';
import axios from 'axios';
import { END_POINT } from '../../../constants/defaultValues';
import { NotificatioErrController, NotificatioSucController } from '../../../helpers/Utils';
// require('dotenv').config();
// import './App.css';

// Lấy API key từ biến môi trường
// const API_KEY = process.env.GEMINI_API_KEY;
const genAI = new GoogleGenerativeAI('AIzaSyC4rnFNie-Ut0CWIFhdSQe4j2dzPZ9lcgs');

function AddProductsFromImage() {
const [prompt, setPrompt] = useState('Hãy trích xuất hình ảnh này dưới dạng một mảng JSON. Mỗi phần tử trong mảng là một đối tượng chứa các thuộc tính "name" (tên nguyên liệu), "unit" (đơn vị đo lường của nguyên liệu), "quantity" (số lượng nhập vào), và "price" (giá tiền nhập). Vui lòng chỉ trả về mã JSON.')
const [image, setImage] = useState(null);
const [imagePreview, setImagePreview] = useState('');
const [rawResult, setRawResult] = useState(''); // Lưu kết quả thô từ API
const [tableData, setTableData] = useState([]); // Dữ liệu đã xử lý cho bảng
const [loading, setLoading] = useState(false); // Trạng thái cho việc trích xuất
const [isSaving, setIsSaving] = useState(false); // Trạng thái cho việc lưu
const [error, setError] = useState('');

 // Hàm chuyển đổi file sang định dạng Base64
async function fileToGenerativePart(file) {
    const base64EncodedDataPromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.readAsDataURL(file);
    });
    return {
        inlineData: { data: await base64EncodedDataPromise, mimeType: file.type },
    };
}

// Hàm phân tích và định dạng dữ liệu JSON cho Handsontable
const parseAndFormatData = (jsonString) => {
    try {
        const cleanedJsonString = jsonString.replace(/```json\n|```/g, '').trim();
        const jsonData = JSON.parse(cleanedJsonString);
        
        if (Array.isArray(jsonData)) {
            // Nếu API trả về trực tiếp mảng, sử dụng luôn
            return jsonData;
        } else if (typeof jsonData === 'object' && jsonData !== null) {
            // Nếu API trả về object { "Category": [...] }, chuyển đổi nó
            const flatData = [];
            for (const category in jsonData) {
                if (Array.isArray(jsonData[category])) {
                    jsonData[category].forEach(item => {
                        flatData.push({
                            name: item.ten_mon || item.name,
                            unit: item.unit,
                            price: item.gia_tien || item.price,
                            quantity: item.gia_tien || item.quantity,
                        });
                    });
                }
            }
            return flatData;
        }
        return []; // Trả về rỗng nếu không phải định dạng mong muốn
    } catch (e) {
        console.error("Lỗi khi phân tích JSON:", e);
        return [];
    }
};

const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        setImage(file);
        setImagePreview(URL.createObjectURL(file));
        setError('');
    }
};

const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt || !image) {
        setError('Vui lòng nhập câu lệnh và chọn một hình ảnh.');
        return;
    }

    setLoading(true);
    setError('');
    setRawResult('');
    setTableData([]);

    try {
        const model = genAI.getGenerativeModel({ model: 'gemini-1.5-flash-latest' });
        const imagePart = await fileToGenerativePart(image);
        const result = await model.generateContent([prompt, imagePart]);
        const response = result.response;
        const text = response.text();
        
        setRawResult(text); // Lưu lại kết quả thô
        const formattedData = parseAndFormatData(text);
        setTableData(formattedData);

        if (formattedData.length === 0) {
        setError("Không thể trích xuất dữ liệu thành bảng. Vui lòng kiểm tra kết quả thô bên dưới.");
        }

    } catch (err) {
        console.error(err);
        setError('Đã xảy ra lỗi khi phân tích hình ảnh. Vui lòng thử lại.');
    } finally {
        setLoading(false);
    }
};

const handleSaveAll = async () => {
    if (tableData.length === 0) {
        setError('Không có dữ liệu để lưu. Vui lòng trích xuất dữ liệu trước.');
        return;
    }
    
    setIsSaving(true);
    setError('');

    try {
        const tokenStr = localStorage.getItem('access_token');
        
        // Gọi đến endpoint mới mà chúng ta sẽ tạo ở backend
        const response = await axios.post(
            `${END_POINT}/stock/bulk-upsert-from-image`,
            tableData, // Gửi toàn bộ mảng dữ liệu
            {
                headers: {
                    Authorization: `Bearer ${tokenStr}`,
                },
            }
        );

        NotificatioSucController(response.data.responseText || 'Import nguyên liệu thành công!');
        
        // Có thể thêm logic reload dữ liệu ở đây nếu cần
        // this.props.reloadProducts();

    } catch (err) {
        const errorMessage = err.response?.data?.responseText || 'Có lỗi xảy ra, vui lòng thử lại.';
        NotificatioErrController(errorMessage);
    } finally {
        setIsSaving(false);
    }
}

return (
    <Row className="app-container">
        <Colxx xxs="5" className="mb-4">
            <h1>✨ Chuyển đổi dữ liệu Nguyên liệu từ hình ảnh ✨</h1>
            <p className="description">
                Sử dụng AI để đọc menu và chuyển thành bảng dữ liệu có thể chỉnh sửa.
            </p>

            <form onSubmit={handleSubmit} className="input-form">
                <textarea
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    placeholder="Nhập câu lệnh yêu cầu AI trả về JSON..."
                    rows="5"
                    className="form-control"
                />
                
                <input 
                    type="file" 
                    onChange={handleImageChange} 
                    accept="image/*"
                    className="form-control-file mt-2"
                />

                {imagePreview && (
                    <div className="image-preview mt-2">
                        <p>Ảnh đã chọn:</p>
                        <img src={imagePreview} alt="Xem trước" />
                    </div>
                )}
                
                <div className="d-flex justify-content-center mt-3">
                    <button onClick={handleSubmit} className="btn btn-primary" type="submit" disabled={loading}>
                        {loading ? 'Đang xử lý...' : 'Trích xuất Menu'}
                    </button>
                </div>
            </form>

            {error && <p className="error-message mt-2 text-danger">{error}`</p>}

            {/* Hiển thị kết quả thô nếu không parse được hoặc để debug */}
            {rawResult && tableData.length === 0 && (
                <div className="mt-3">
                    <h2>Kết quả thô từ API:</h2>
                    <pre>{rawResult}</pre>
                </div>
            )}
        </Colxx>
        <Colxx xxs="7" className="mb-4">
            <div className="result-container">
                {tableData.length > 0 && (
                    <>
                        <h2>Kết quả dạng bảng:</h2>
                        <HotTable
                            data={tableData}
                            colHeaders={['Tên sản phẩm', 'Đơn vị tính', 'Số lượng nhập', 'Giá tiền']}
                            columns={[
                                { data: 'name' },
                                { data: 'unit' },
                                { data: 'quantity' },
                                { data: 'price', type: 'numeric', numericFormat: { pattern: '0,0' } }
                            ]}
                            rowHeaders={true}
                            width="100%"
                            height="auto" // Tự động điều chỉnh chiều cao
                            stretchH="all" // Kéo dài các cột để vừa với container
                            licenseKey="non-commercial-and-evaluation" // Bắt buộc cho bản miễn phí
                            contextMenu={true} // Bật menu chuột phải
                            dropdownMenu={true} // Bật menu lọc/sắp xếp
                        />
                        <div className="d-flex justify-content-center mt-3">
                            <button onClick={handleSaveAll} className="btn btn-primary" disabled={isSaving}>
                                {isSaving ? 'Đang lưu...' : 'Lưu tất cả vào hệ thống'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </Colxx>
    </Row>
);
}

export default AddProductsFromImage;